import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import Utils from 'Utils/utils';

const SavedSearch = observer(props => {
  console.log('props savedsearch', props);
  const data = userDetail.contactSavedSearches;

  const redirectToPath = e => {
    e.preventDefault();
    // debugger;
    const redirectPath = e.currentTarget.getAttribute('data-path');
    console.log('redirectPath ', redirectPath);
    if (
      redirectPath !== null &&
      redirectPath.includes('/advanced-search/contact')
    )
      Utils.setLocalStorage('companySearch', false);
    props.history.push(redirectPath);
  };

  const tryLeadBuilder = e => {
    props.history.push('/advanced-search/contact');
  };

  return (
    <div className="card">
      <div className="card-header">
        <h6 className="card-title">Saved Searches</h6>
        {/* <Link
          onClick={redirectToPath}
          data-path="/advanced-search/contact"
          to="/advanced-search/contact"
        >
          View all
        </Link> */}
      </div>
      <div className="card-body">
        {data.length ? (
          <ul>
            {data.map((item, index) => {
              return (
                <li key={item.id}>
                  <Link
                    onClick={redirectToPath}
                    data-path={`/advanced-search/contact/${item.id}`}
                    to={`/advanced-search/contact/${item.id}`}
                  >
                    <span>{item.templateName}</span>
                    <i className="material-icons">call_made</i>
                  </Link>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="no-data-exist-card">
            Create your saved search and get notified when new leads are added
            <div className="nolist-action-wrap">
              <div
                className="contact-action-btn"
                onClick={e => tryLeadBuilder(e)}
              >
                Try Lead Builder
              </div>
            </div>
          </div>
        )}
        {/* <div className="cover-scroll-bar"/> */}
      </div>
    </div>
  );
});

export default withRouter(SavedSearch);
